(() => {
  'use strict';

  const initGallery = (root) => {
    if (root.dataset.zvCoreGalleryReady === 'true') return;
    root.dataset.zvCoreGalleryReady = 'true';

    const track = root.querySelector('[data-gallery-track]');
    const stage = root.querySelector('[data-gallery-stage]');
    const allSlides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const allThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const current = root.querySelector('[data-gallery-current]');
    const total = root.querySelector('[data-gallery-total]');
    const viewMediaLabel = root.dataset.labelViewMedia || window.ZinVoltI18n.t("view_media_index_of_total_c9149d");
    const visibleInGalleryOrder = (items) => items
      .filter((item) => !item.hidden)
      .map((item, domIndex) => ({
        item,
        domIndex,
        order: Number.parseInt(window.getComputedStyle(item).order, 10) || 0
      }))
      .sort((first, second) => first.order - second.order || first.domIndex - second.domIndex)
      .map(({ item }) => item);
    const formatLabel = (template, replacements) => Object.entries(replacements).reduce(
      (label, [key, value]) => label.split(`[${key}]`).join(String(value)),
      template
    );
    const initialSlides = visibleInGalleryOrder(allSlides);
    const initialActive = initialSlides.findIndex((slide) => slide.classList.contains('is-active'));
    let index = initialActive >= 0
      ? initialActive
      : Math.max(0, Number(root.dataset.activeMediaIndex || 0));
    let pointerStart = null;

    if (!track || !initialSlides.length) return;

    const show = (requestedIndex, announce = true) => {
      const slides = visibleInGalleryOrder(allSlides);
      const thumbs = visibleInGalleryOrder(allThumbs);
      if (!slides.length) return;

      index = (requestedIndex + slides.length) % slides.length;
      track.style.setProperty('--zv-gallery-offset', `${index * -100}%`);

      const activeSlide = slides[index];
      const activeThumb = thumbs.find((thumb) => thumb.dataset.mediaId === activeSlide.dataset.mediaId) || thumbs[index];

      allSlides.forEach((slide) => {
        const active = slide === activeSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });

      allThumbs.forEach((thumb) => {
        const active = thumb === activeThumb;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.tabIndex = active ? 0 : -1;
      });

      thumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-label', formatLabel(viewMediaLabel, {
          index: thumbIndex + 1,
          total: slides.length
        }));
        thumb.setAttribute('aria-posinset', String(thumbIndex + 1));
        thumb.setAttribute('aria-setsize', String(slides.length));
      });

      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(slides.length);
      if (previous) previous.hidden = slides.length < 2;
      if (next) next.hidden = slides.length < 2;

      const rail = activeThumb?.parentElement;
      if (activeThumb && rail && typeof rail.scrollTo === 'function') {
        rail.scrollTo({
          left: Math.max(0, activeThumb.offsetLeft - ((rail.clientWidth - activeThumb.clientWidth) / 2)),
          top: Math.max(0, activeThumb.offsetTop - ((rail.clientHeight - activeThumb.clientHeight) / 2)),
          behavior: announce ? 'smooth' : 'auto'
        });
      }
    };

    previous?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));

    allThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const thumbs = visibleInGalleryOrder(allThumbs);
        const thumbIndex = thumbs.indexOf(thumb);
        if (thumbIndex >= 0) show(thumbIndex);
      });
      thumb.addEventListener('keydown', (event) => {
        const thumbs = visibleInGalleryOrder(allThumbs);
        const thumbIndex = thumbs.indexOf(thumb);
        if (thumbIndex < 0) return;
        let target = null;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = thumbIndex - 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = thumbIndex + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = thumbs.length - 1;
        if (target === null) return;
        event.preventDefault();
        show(target);
        thumbs[index]?.focus();
      });
    });

    stage?.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') pointerStart = event.clientX;
    });
    stage?.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) >= 45) show(distance > 0 ? index - 1 : index + 1);
    });
    stage?.addEventListener('pointercancel', () => { pointerStart = null; });

    show(Math.min(index, initialSlides.length - 1), false);
  };

  document.querySelectorAll('[data-zv-product-hero][data-is-core-lead="true"]').forEach(initGallery);
})();
